module.exports = __webpack_public_path__ + "img/coal-liquefaction.1e94d211.png";